import React, { useEffect, useState } from "react";
import "../pages/styles/gameplay.css";
import "../pages/styles/home.css";
import "./styles/mediaqueries.css";
import runeCrystal from "../Assets/images/runecrystal.png";
import blueGem from "../Assets/images/blue_gem.png";
import greenGem from "../Assets/images/green_gem.png";
import gameplay1 from "../Assets/images/zodiac3.jpg";
import gameplay2 from "../Assets/images/marketplace1.jpg";
import gameplay3 from "../Assets/images/Gameplay_Img03_2.jpg";
import gameplay4 from "../Assets/images/Gameplay_Img04.jpg";
import gameplay5 from "../Assets/images/Gameplay_Img05.jpg";
import carouselButton1 from "../Assets/images/icon-1.png";
import carouselButton2 from "../Assets/images/icon-2.png";
import carouselButton3 from "../Assets/images/icon-3.png";
import marketplace from "../Assets/images/marketplace.jpg";
import enemylevels from "../Assets/images/enemylevels.jpg";
import customization from "../Assets/images/customization.jpg";
import zodiac1 from "../Assets/images/zodiac1.jpg";
import zodiac2 from "../Assets/images/zodiac2.jpg";
import itemization from "../Assets/images/itemization.jpg";
import navBtn from "../Assets/images/Gameplay_Top_Nav_Btn.png";
import navBtnActive from "../Assets/images/Gameplay_Top_Nav_Btn_Current.png";
import carouselLine from "../Assets/images/Gameplay_Top_Nav_line.png";
import Footer from "../components/Footer";
import crystal1 from "../Assets/images/mithril-crystal1.png";
import crystal2 from "../Assets/images/arcane-crystal1.png";
import crystal3 from "../Assets/images/prismitic-crystal.png";

const Gameplay = () => {
  const [video1Loading, setVideo1Loading] = useState(true);
  const [activeIndex, setActiveIndex] = useState(0);
  // const [carouselIsLooping, setCarouselIsLooping] = useState(false);

  const carouselData = [
    {
      icon: carouselButton1,
      title: "Heroes",
      image: gameplay1,
      desc: (
        <span>
          Roshpit Champions 2 starts off with your choice of 1 of 17 available
          classes. Your hero class determines your Base Attack, starting
          Abilities and Talents set, and a stat growth curve. As you grow your
          character, you have the option to learn skills from other classes and
          gain access to their stat growth tree.
          <br />
          <br />
          Roshpit Champions 1 had 30 classes, and we intend to have all 30
          implemented as early as possible.
        </span>
      ),
    },
    {
      icon: carouselButton2,
      title: "Game World",
      image: gameplay2,
      desc: (
        <span>
          After experiencing a near-death experience, your hero finds themselves
          transported into an unknown realm full of danger and mystery. Players
          will battle their way through diverse biomes, facing more challenging
          enemies and bosses as they progress deeper into the world. Worlds are
          non-linear and have hidden secrets around every corner! Heroes will
          acquire gear and level ups through experience gain in order to
          progressively take on more powerful monsters.
        </span>
      ),
    },
    {
      icon: carouselButton3,
      title: "Equipment & Loot",
      image: gameplay3,
      desc: (
        <span>
          Experience a new take on ARPG equipment, where each piece of gear has
          a keystone modifier that can completely change how your abilities and
          attacks can function. Legendary items can roll up to 9 affixes in
          addition to the keystone, making the perfect piece of gear a rare and
          exciting find. Some rare items can also grant abilities from other
          classes, adding even more variance to your build possibilities.
        </span>
      ),
    },
    {
      icon: carouselButton1,
      title: "Single and Multiplayer Game Modes",
      image: gameplay4,
      desc: (
        <span>
          RPC2 grants flexibility in how you engage with the game. There is a
          fully Offline Single Player, a Self Hosted Multiplayer, and a
          Dedicated Multiplayer environment. Multiplayer mode has refined
          netcode, making it feel as smooth as Single Player.
        </span>
      ),
    },
    {
      icon: carouselButton2,
      title: "Monsters and Bosses",
      image: gameplay5,
      desc: (
        <span>
          RPC2 has a very high monster variety, with approximately 70+ unique
          monster types per zone. Monsters have unique skill sets that challenge
          the player to adapt to new moves, and passive powers which will keep
          you on your feet. Each map also contains multiple large bosses with
          several abilities that will drop a large quantity of loot with
          enhanced rarity.
        </span>
      ),
    },
  ];
  useEffect(() => {
    document.title = "Roshpit Champions II | Gameplay";
    window.scrollTo(0, 0);
  }, []);
  // useEffect(() => {
  //   if (activeIndex <= carouselData.length - 1) {
  //     const id = setTimeout(() => {
  //       setActiveIndex((activeIndex) => activeIndex + 1);
  //       return () => clearTimeout(id);
  //     }, 2000);
  //   } else {
  //     setActiveIndex(0);
  //   }
  // }, [activeIndex]);

  return (
    <>
      <div className="gameplay_section">
        <div className="gameplay_section_video">
          {/* <div className="gameplay_section_video_text">
            <p className="gameplay_section_video_text_heading gradient_heading">
              Gameplay
            </p>
            <span className="gameplay_section_video_text_span">
              Lorem ipsum dolor sit amet consectetur. Quam risus volutpat semper
              risus ullamcorper vitae est ipsum. Morbi sagittis sagittis
              facilisis elementum sapien senectus netus sed sed.
            </span>
          </div> */}
          <video autoPlay muted loop id="myVideo">
            <source
              src="https://rpc2-game.s3.us-west-1.amazonaws.com/RpcData/site_video_files/Fast+Pace+2+No+Audio.mp4"
              type="video/mp4"
            />
          </video>
          {/* </div> */}
          <div className="bottom_carousel">
            {/* <div className="bottom_carousel_heading">
              <p className="gradient_heading">Enter the Roshpit</p>
              <span>
                The Champions, once again, hear the howls of the Roshpit. Blaze
                your way through the Tanari Jungles with one of the many heroes
                from the original game. With whole new looks, familiar names and
                items, along with brand new gameplay elements, we hope that you
                enjoy the game we've spent many years creating and will continue
                to improve upon.
              </span>
            </div> */}
            {/* <div className="bottom_carousel_buttons">
              {carouselData?.map((item, index) => {
                return (
                  <div className="bottom_carousel_buttons_item">
                    <button
                      style={{
                        boxShadow:
                          activeIndex === index
                            ? "0px 0px 20px #b79155"
                            : "none",
                      }}
                      onClick={() => setActiveIndex(index)}
                    >
                      <img src={item.icon} alt={item.title} />
                    </button>{" "}
                    <p>{item.title}</p>
                  </div>
                );
              })}
            </div> */}
            {/* <div className="bottom_carousel_carousel">
              <div className="bottom_carousel_carousel_prev">
                <button
                  onClick={() => {
                    if (activeIndex > 0) {
                      setActiveIndex(activeIndex - 1);
                    } else if (activeIndex === 0) {
                      setActiveIndex(carouselData?.length - 1);
                    }
                  }}
                >
                  <i class="bi bi-caret-left-fill"></i>
                </button>
              </div>
              <div className="bottom_carousel_carousel_image">
                <img
                  src={carouselData[activeIndex]?.image}
                  alt={carouselData[activeIndex]?.title}
                />
              </div>
              <div className="bottom_carousel_carousel_next">
                <button
                  onClick={() => {
                    if (activeIndex < carouselData?.length - 1) {
                      setActiveIndex(activeIndex + 1);
                    } else if (activeIndex == carouselData?.length - 1) {
                      setActiveIndex(0);
                    }
                  }}
                >
                  <i class="bi bi-caret-right-fill"></i>
                </button>
              </div>
            </div> */}
            <div className="bottom_carousel_details">
              <p>{carouselData[activeIndex]?.title}</p>
              <span>{carouselData[activeIndex]?.desc}</span>
            </div>
            <div className="bottom_carousel_navigation_buttons">
              <img
                className="bottom_carousel_navigation_buttons_line"
                src={carouselLine}
                alt=""
                srcset=""
              />
              {[...Array(5)].map((item, index) => (
                <button key={index} onClick={() => setActiveIndex(index)}>
                  <img
                    src={activeIndex === index ? navBtnActive : navBtn}
                    alt=""
                  />
                </button>
              ))}
            </div>
          </div>
        </div>
        <div className="gameplay_section_container">
          <div className="gameplay_section_container_wrapper container">
            <div className="gameplay_section_container_wrapper_currency">
              {/* <div className="gameplay_section_container_wrapper_currency_image">
                <img src={coin} alt="coin" />
              </div> */}
              <div className="gameplay_section_container_wrapper_currency_text">
                <p className="gameplay_section_container_wrapper_currency_text_heading">
                  Game Currency
                </p>
                <span className="gameplay_section_container_wrapper_currency_text_span">
                  Similar to the first game, there are 3 main forms of currency
                  in Roshpit Champions II. Fight through mobs, destroy world
                  bosses, participate in challenges, and fulfill quests to
                  gather the resources of Tanari Jungle.
                </span>
              </div>
            </div>
            <div className="currency_container container">
              <div className="currency_card">
                <div className="currency_card_image">
                  <img src={crystal1} alt="blueGem" />
                </div>
                <p className="currency_card_name">
                  Mithril Shards <p className="currency_card_type">Common</p>
                </p>

                <p className="currency_card_desc">
                  Considered the primary currency. It is used to reroll
                  equipment stats and to purchase common items. Acquired by
                  defeating main bosses.
                </p>
              </div>
              <div className="currency_card">
                <div className="currency_card_image">
                  <img src={crystal2} alt="runeCrystal" />
                </div>
                <p className="currency_card_name">
                  Arcane Crystal{" "}
                  <p className="currency_card_type type2">Rare</p>
                </p>

                <p className="currency_card_desc">
                  Used to craft glyphs and purchase talent respects. Acquired by
                  defeating Elite mobs.
                </p>
              </div>

              {/* <div className="currency_card">
                <div className="currency_card_image">
                  <img src={crystal3} alt="greenGem" />
                </div>
                <p className="currency_card_name">
                  Prismatic Gemstones
                  <p className="currency_card_type type3">Super Rare</p>
                </p>
                <p className="currency_card_desc">
                  Used to craft gems which can be inserted into gear’s empty
                  sockets. Acquired by completing hourly challenges and other
                  events.
                </p>
              </div> */}
            </div>
          </div>
        </div>
        {/* <div className="gameplay_video1">
          {video1Loading && (
            <div className="video_overlay1">
              <div className="lds-ripple">
                <div></div>
                <div></div>
              </div>
              <p>Loading video...</p>
            </div>
          )}
          <video
            autoPlay
            muted
            loop
            onLoadedData={() => {
              setVideo1Loading(false);
            }}
          >
            <source
              src="https://rpc2-game.s3.us-west-1.amazonaws.com/RpcData/Trailers/Trailer_2.webm"
              type="video/mp4"
            />
          </video>
        </div> */}
        {/* <div className="gameplay_section_container_wrapper container">
          <div
            className="gameplay_section_container_wrapper_currency"
            style={{
              flexDirection: "column",
              display: "flex",
              alignItems: "flex-start",
            }}
          >
            <div className="gameplay_section_container_wrapper_currency_image">
                <img src={coin} alt="coin" />
              </div>
            <div className="gameplay_section_container_wrapper_currency_text">
              <p className="gameplay_section_container_wrapper_currency_text_heading gradient_heading">
                Marketplace
              </p>
              <span className="gameplay_section_container_wrapper_currency_text_span">
                After much deliberation on how to best implement a marketplace,
                we thought the best way would be to have it in-game. This way,
                you can go to town, put an item up for trade/sale, and then go
                straight to fighting baddies again. To use the Marketplace,
                please go to town and speak with Fable, the Consignment
                Auctioneer.
              </span>
              <img src={marketplace} alt="" />
              <span className="gameplay_section_container_wrapper_currency_text_span">
                You will have the choice of 'x,y,z'. Upon selecting X, you will
                be able to list the item you want for trade. Once confirmed,
                this item will now be visible to all players and will allow it
                to be bought. The next time you see Fable, he will give you your
                earnings, minus his 10% cut (lower for Battle Pass).
                <br></br>
                In the future, we may implement a way to trade outside of the
                game as well
              </span>
            </div>
            <div className="gameplay_section_container_wrapper_currency_text">
              <p className="gameplay_section_container_wrapper_currency_text_heading gradient_heading">
                Zodiac Board
              </p>
              <span className="gameplay_section_container_wrapper_currency_text_span">
                Similar to skill trees and paragon boards, Roshpit II introduces
                the Zodiac. This Tri-force looking thing may look daunting at
                first - something we've tried to avoid to keep our game simple.
                However, we felt that adding this brought substantial substance
                to the endgame and brought much needed earlygains for certain
                heroes. You can gain Zodiac points by leveling up, completing
                quests, and competing in world events. While we have to put
                maximum point limits, we wanted you to be able to get the points
                playing the style you want to. To also make it easier for
                beginners, we have an auto-assign button that will auto-assign
                points for you.
              </span>
              <img src={zodiac1} alt="" />
              <span className="gameplay_section_container_wrapper_currency_text_span">
                While we can't compete on graphics with the AAA games, we think
                our Zodiac board looks the best. Once completed, you will see
                the board create a beautiful constellation for you to look at.
                =)
              </span>
              <img src={zodiac2} alt="" />
            </div>
            <div className="gameplay_section_container_wrapper_currency_text">
              <p className="gameplay_section_container_wrapper_currency_text_heading gradient_heading">
                Itemization
              </p>
              <span className="gameplay_section_container_wrapper_currency_text_span">
                There are 6? classes of items (Normal, Magic, Rare, Legendary,
                Mythic, Arcana) Normal items, like other action-RPGs, are used
                in the early game and are promptly trashed when a colored item
                drops. However, because we care about the environment, we are
                introducing the Recycling feature. If you bring your normal or
                magic items to the Dragon Blacksmith, he will recycle them for
                you and provide you with a green voucher (get it?) With 100
                green vouchers, you can trade it for a mystery box. The mystery
                box will have a 60% chance at a Rare, 25% chance at a Legendary,
                a 5% chance at an Arcana, and a 10% chance at a Mythic. You can
                also trade the mystery boxes themselves.
              </span>
              <img src={itemization} alt="" />
              <span className="gameplay_section_container_wrapper_currency_text_span">
                Each class of item will have a different number of Attribute
                slots. Most attributes take one spot but certain ones take two.
                <br></br>
                Arcana Items are extremely rare and contained pre-determined
                skills with random rolls. These are game-changing as they
                introduce new skills or enhancements that will change your
                character. You can build around these Arcanas to make totally
                different builds.
              </span>
            </div>
            <div className="gameplay_section_container_wrapper_currency_text">
              <p className="gameplay_section_container_wrapper_currency_text_heading gradient_heading">
                Customization
              </p>
              <span className="gameplay_section_container_wrapper_currency_text_span">
                You are probably wondering 'That's great and all, but to find
                one of those perfect skill-items must take years of grinding...'
                While grinding is one of the important aspects of action-RPGs,
                it should not be the only reason you play the game. This is why
                our Dragon Blacksmith can help you reroll your item
                attributes... on... every... single... attribute.
              </span>
              <img src={customization} alt="" />
              <span className="gameplay_section_container_wrapper_currency_text_span">
                The way it works is that you can 'lock' an attribute that you
                like. You can 'lock' as many as you want. The more that you
                'lock', the harder Dragon Blacksmith has to work - hence his
                extra charges. For example, if you have an item with 8 slots and
                you have 6 awesome attributes but want to replace two of them,
                you don't have to spend hours grinding finding the 'perfect'
                item. Instead, you will lock 6 of the slots and pay the Dragon
                Blacksmith to reroll only 2 of the slots for you.
                <br></br>
                Yes, the cost of this is pretty high for locking 6 slots but we
                think it's much easier than finding a perfect item with 8
                awesome rolls
              </span>
            </div>
            <div className="gameplay_section_container_wrapper_currency_text">
              <p className="gameplay_section_container_wrapper_currency_text_heading gradient_heading">
                Enemy Levels
              </p>
              <span className="gameplay_section_container_wrapper_currency_text_span">
                By now, I hope you can understand the team's appreciation for
                action-RPGs. We played a lot of them and enjoyed many aspects of
                each. We tried to take the best from each and make the perfect
                mixture for you. While we understand Enemy Scaling would help
                with longevity, we thought that this unfairly punishes players
                who level up faster. Part of the fun in action-RPGs is getting
                OP builds and flying through enemies. Therefore, we decided to
                stick with the old formula but also introduce a super hard
                difficulty.
              </span>
              <img src={enemylevels} alt="" />
              <span className="gameplay_section_container_wrapper_currency_text_span">
                For Normal and Legend gameplay, you will have static level
                enemies that (hopefully) progress in difficulty as you play.
                However, upon reaching level 80, you can unlock Impossible
                difficulty which makes all enemies level 100. Honestly, it will
                be almost impossible to beat this difficulty, even with a full
                party. But we put it in there - just for you. =)
              </span>
            </div>
          </div>
        </div> */}
        {/* <div className="gameplay_video1" style={{ marginTop: "40px" }}>
          {video1Loading && (
            <div className="video_overlay1">
              <div className="lds-ripple">
                <div></div>
                <div></div>
              </div>
              <p>Loading video...</p>
            </div>
          )}
          <video
            autoPlay
            muted
            loop
            onLoadedData={() => {
              setVideo1Loading(false);
            }}
          >
            <source
              src="https://rpc2-game.s3.us-west-1.amazonaws.com/RpcData/Trailers/Trailer_3.webm"
              type="video/mp4"
            />
          </video>
        </div> */}
        <div className="section_three_gameplay">
          <div className="container">
            <div className="game_features_container flex-column flex-md-row gap-md-5">
              <div className="about-image">
                <img src={gameplay1} alt="" srcset="" />
              </div>
              <div className="game_features_info">
                <p className="game_features_info_heading ">Zodiac Board</p>

                <span>
                  With each level up, players can navigate their Zodiac Tablet
                  which gives them control over their stat gains. As your
                  adventure progresses, you will find tablets from other classes
                  which you can attach to your core tablet, granting maximum
                  flexibility to your character’s stat profile.
                </span>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="game_features_container flex-column flex-md-row gap-md-5">
              <div className="game_features_info">
                <p className="game_features_info_heading ">Marketplace</p>

                <span>
                  Each hero can’t possibly use every piece of gear that they
                  find! Players have the option to buy and sell their gear using
                  a fully integrated in-game auction house that facilitates
                  trading without having to manually find a buyer or seller.
                  Players can sell, earn, and reinvest to find that perfect
                  piece for their collection.
                </span>
              </div>
              <div className="about-image">
                <img src={gameplay2} alt="" srcset="" />
              </div>
            </div>
          </div>
        </div>
        <div className="section_three_gameplay flex-row container">
          <div className="container">
            <div className="game_features_container flex-column">
              <div className="about-image">
                <img src={gameplay3} alt="" srcset="" />
              </div>
              <div className="game_features_info">
                <p className="game_features_info_heading ">Itemization</p>

                <span>
                  Items have 5 rarity levels, Normal, Magic, Rare, Mythical, and
                  Legendary. Legendary items have the top power potential, as
                  they roll up to 10 affixes. Each unique item has a “Keystone
                  Affix” which adds a brand new power to your character and can
                  modify how your skills function. Items also have a chance to
                  roll entirely new abilities which can switch up your
                  character’s playstyle. Ultra-rare “Blessing” affixes can be
                  rolled, which will enhance other affixes, pushing your power
                  beyond what is normally possible. Getting a perfect piece of
                  gear with 7 ideal affixes, a keystone affix, a sub-ability
                  with the right randomly rolled talent points, as well as the
                  correct blessing is incredibly rare, so the hunt for the
                  perfect item is always alive.
                </span>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="game_features_container flex-column">
              <div className="about-image">
                <img src={gameplay4} alt="" srcset="" />
              </div>
              <div className="game_features_info">
                <p className="game_features_info_heading ">Crafting</p>

                <span>
                  Players don’t always have to rely on perfect RNG in order to
                  acquire powerful items. The Dragon Blacksmith grants players
                  flexibility in how they build up items. Lower rarity items can
                  have affixes, blessings, and talents added to gear, at the
                  cost of resources and rare reagents. You can buy the reagents
                  you need on the Marketplace, so acquiring base currency will
                  ensure that you will eventually be able to get the item you
                  need without having to wait for the stars to align.
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="section_three_gameplay dark">
          <div className="container">
            <div className="game_features_container flex-column flex-md-row gap-md-5">
              <div className="about-image">
                <img src={gameplay5} alt="" srcset="" />
              </div>
              <div className="game_features_info">
                <p className="game_features_info_heading ">
                  Multiple Game Modes
                </p>

                <span>
                  Roshpit Champions 2 has the main Adventure Mode, and
                  additionally a rogue-like mode for quick gameplay sessions.
                  Adventure Mode has players exploring large maps, hunting
                  bosses and building a permanent character. Rogue Mode has
                  players starting at level 1 each time, with meta upgrades
                  in-between runs. Both modes can be played Single Player,
                  Self-Hosted multiplayer or in a dedicated online environment.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="footer_download">
        <div className="footer_download_container flex-column flex-md-row">
          <div className="footer_download_btn">
          <button className="btn">Download Now</button>
        </div> 
        </div>
      </div> */}

      <Footer />
    </>
  );
};

export default Gameplay;
